import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import {} from "@/api";
import DescribeObjectStore from "./DescribeObjectStore.vue";
import ObjectStoreSelectButtonPopover from "./ObjectStoreSelectButtonPopover.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectStoreSelectButtonDescribePopover',
    props: {
        idPrefix: null,
        what: null,
        objectStore: null
    },
    setup(__props) {
        const props = __props;
        const target = computed(() => {
            return `${props.idPrefix}-object-store-button-${props.objectStore.object_store_id}`;
        });
        const title = computed(() => {
            return props.objectStore.name;
        });
        return { __sfc: true, props, target, title, DescribeObjectStore, ObjectStoreSelectButtonPopover };
    }
});
